import React from 'react';
import TTLProxy from "../../common/TTLAsyncProxy";
import Utils from "../../common/Utils";
import PropTypes from 'prop-types';

/**
 * RoleRender
 * Description: Renders content based on user role
 */
class RoleRender extends React.Component{

    static propTypes = {
        role: PropTypes.any,
        component: PropTypes.any
    };

    constructor(props){
        super(props);

        const proxy = TTLProxy.getInstance();

        this.state = {
            role: proxy.getUserRole()
        };
    }

    _renderComponent() {
        let Component = this.props.component;
        return Component
            ? <Component roles={this.props.role}/> : null;
    }


    render(){
        return Utils.hasRole(this.state.role,this.props.role)   ? this.props.children
            : this._renderComponent();
    }

}
export default RoleRender;


// WEBPACK FOOTER //
// ./src/components/RoleRender/RoleRender.js